import {isUndefined} from "lodash";
import {useMemo} from "react";
import {env} from "../../constants";

export const minPartialPaymentInCents = 500;

export const useIsValidAmount = (amount: number | undefined, planBalance: number | undefined): boolean => {
  return useMemo(() => {
    if (["staging"].includes(env)) {
      return true; // in staging, we bypass the validation for testing purposes
    }
    if (planBalance && !isUndefined(amount)) {
      if (planBalance >= minPartialPaymentInCents) {
        return amount >= minPartialPaymentInCents && amount <= planBalance;
      }
      return amount > 0 && amount <= planBalance;
    }

    return !!planBalance;
  }, [amount, planBalance]);
};
